import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EstreamPanel } from 'brain-data/model/estream-panel.model';

@Injectable({ providedIn: 'root' })
export class EstreamPanelService {
  constructor(private http: HttpClient) {}

  getPanels(): Observable<EstreamPanel[]> {
    return this.http.get<EstreamPanel[]>(`${environment.apiBaseUrl}/brain/diff/panels/contract-numbers`);
  }
}
